export default __webpack_public_path__ + "static/media/empty_stats.912ee5b6.png";